import React, { PureComponent } from 'react';
import {
PieChart, Pie, Cell, BarChart, Bar, LineChart,
Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend
} from 'recharts';
import { connect } from 'react-redux';
import './Reports.css';
import { relative } from 'path';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8B008B'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
const x = cx + radius * Math.cos(-midAngle * RADIAN);
const y = cy + radius * Math.sin(-midAngle * RADIAN);

return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
    </text>
);
};

class ReportBuilder extends PureComponent {

render() {
    console.log(this.props.data);
    return (
        <div >
            <div className="reportsContainer">
                <LineChart
                    width={500}
                    height={300}
                    data={this.props.data.CYNumberOfActivities}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="Luna" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="Numar_de_activitati" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart>    
                <BarChart
                    width={500}
                    height={300}
                    data={this.props.data.CYHoursOfVolunteering}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="Luna" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Ore_de_voluntariat" fill="#8884d8" />
                </BarChart>
            </div>
            <div className="reportsContainer">
            <LineChart
                    width={500}
                    height={300}
                    data={this.props.data.CYActiveVolunteers}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="Luna" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="Voluntari_activi" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart> 
            <BarChart
                    width={500}
                    height={300}
                    data={this.props.data.CYNewVolunteers}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="Luna" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Voluntari_noi" fill="#8884d8" />
                    <Bar dataKey="Voluntari_noi_activi" fill="#00C49F" />
                </BarChart>
            </div>
            <div className="reportsContainer">
                <PieChart width={500} height={300}>
                    <Pie
                        data={this.props.data.CYWeightOfDomains}
                        cx={200}
                        cy={200}
                        labelLine={false}
                        label={renderCustomizedLabel}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="Numar_ore"
                    >
                        {
                            this.props.data.CYWeightOfDomains.map((entry, index) => 
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} name={`${entry.Domeniu}`}/>)
                        }
                    </Pie>
                    <Legend wrapperStyle={{ position: relative }}/>
                </PieChart>
            </div>
        </div>
    );
}
}

function mapStateToProps(state) {

return {
    data: state.table.data,
}
}

export default connect(mapStateToProps)(ReportBuilder);


// WEBPACK FOOTER //
// ./src/views/Reports/Reports.js